import React from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import { Provider } from 'react-redux'
import { configureStore } from '../../../store'
import App from './App'
import { Container } from 'semantic-ui-react'

const store = configureStore()

export default () => (
    <Provider store={store}>
        <Router>
            <div>
                {/* <Container> */}
                <App />
                {/* </Container> */}
            </div>
        </Router>
    </Provider>
)


// WEBPACK FOOTER //
// ./src/display/features/ui/components/Root.prod.js